import m2Sidebar from "@components/sidebar/m2_sidebar";
export default {
  components: {
    m2Sidebar: m2Sidebar
  },
  data: function () {
    return {
      batchList: [],
      batch_id: ""
    };
  },
  created: function () {
    this.getData();
    this.$store.commit("setHeaderState", "2");
  },
  methods: {
    getData: function () {
      if (this.$store.state.examInfo.currentExamInfo.batch_id) {
        this.batch_id = this.$store.state.examInfo.currentExamInfo.batch_id;
        this.nextStep()
      } else {
        this.$http.get(globalProvider.serviceUrl("e_reg/g/bli/v2")).then(data => {
          if (data.body.code === resultCode.Success) {
            if (data.body.data.length == 0) {
              this.$router.push({ name: "default.examReg.orderCloseTip" });
            } else if (data.body.data.length == 1) {
              this.batch_id = data.body.data[0].id;
              this.nextStep();
            } else {
              this.batchList = data.body.data;
            }
          } else if (data.body.code == resultCode.NotSuccess) {
            this.$alert(getErrorMessage(data.body.message), "提示", {
              confirmButtonText: "确定"
            });
          }
        });
      }

    },
    nextStep: function () {
      if (this.batch_id !== "") {
        this.$http
          .get(globalProvider.serviceUrl("e_reg/g/bpe/{batch_id}"), {
            params: {
              batch_id: this.batch_id
            }
          })
          .then(data => {
            if (data.body.code === resultCode.Success) {
              this.$router.push({ name: "order" });
            } else if (data.body.code == resultCode.NotSuccess) {
              this.$alert(getErrorMessage(data.body.message));
            }
          });
      } else {
        this.$alert("请选择一个批次", "提示", {
          confirmButtonText: "确定"
        });
      }
    }
  }
};